/**
 * Точка входа React приложения: монтирование корневого компонента в DOM
 * Дата: 24.01.2026 - Добавлена инициализация логгера и ErrorBoundary
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { logger } from './utils/logger';

// Инициализируем логгер при старте приложения
logger.init();

// Логируем запуск приложения
logger.info('app_started', {
  version: import.meta.env.VITE_APP_VERSION || '1.0.0',
  environment: import.meta.env.MODE,
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

